import { Badge, type BadgeTone } from '@/core/ui';
import { CourseStatus, STATUS_LABELS } from '../domain/course';

const TONES: Record<string, BadgeTone> = {
  [CourseStatus.DRAFT]: 'warning',
  [CourseStatus.PUBLISHED]: 'success',
  [CourseStatus.ARCHIVED]: 'neutral',
};

export function StatusBadge({ status }: { status: string }) {
  return <Badge tone={TONES[status] ?? 'neutral'}>{STATUS_LABELS[status] ?? status}</Badge>;
}
